import React, { useEffect } from "react"
import { Button, Card, Popconfirm, Tree } from "antd";
import { YhBox } from '@/components/YhBox'
// import { useDictModel } from "../../dict/dictModel"
import { globalPrompt } from '@/components/message'
import { useOrgModel } from "../orgModel"
import { IOrganDetail, OptType } from "../orgTypes"
import { DataNode, EventDataNode } from "antd/lib/tree";
import { IVRMOrgDetail } from "../orgService";

const OrganOldTree = () => {
    const { treeOldSource, loadOldData, setSelectedNodes, selectedNodes, } = useOrgModel();

    useEffect(() => {
        loadOldData();
    }, [])


    const onSelect = (selectedKeys: React.Key[], info: {
        event: "select";
        selected: boolean;
        node: EventDataNode;
        selectedNodes: DataNode[];
        nativeEvent: MouseEvent;
    }) => {
        let selectNode = info.selectedNodes as IVRMOrgDetail[];
        setSelectedNodes(selectNode);
    };

    return <>
         <Tree
            defaultExpandedKeys={[selectedNodes[0]?.key]}
            selectedKeys={[selectedNodes[0]?.key]}
            titleRender={(node: any) => `${node.name}`}
            onSelect={onSelect}
            treeData={treeOldSource}
        />
    </>
}
export default OrganOldTree